import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative mt-2 rounded-md shadow-sm" }
const _hoisted_2 = { class: "text-sm capitalize" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "inline-flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" URL ")
const _hoisted_6 = { class: "inline-flex items-center ml-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Upload Image ")
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_10 = ["required"]
const _hoisted_11 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? "*" : ""), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "url",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mode) = $event)),
          class: "mr-2"
        }, null, 512), [
          [_vModelRadio, _ctx.mode]
        ]),
        _hoisted_5
      ]),
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "upload",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mode) = $event)),
          class: "mr-2"
        }, null, 512), [
          [_vModelRadio, _ctx.mode]
        ]),
        _hoisted_7
      ])
    ]),
    (_ctx.mode === 'url')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_InputText, {
            type: "text",
            label: "imagu Url",
            keyValue: "imageUrl",
            placeholder: "Enter image URL",
            value: _ctx.imageUrl || '',
            onUpdate: _ctx.updateValue,
            required: _ctx.required
          }, null, 8, ["value", "onUpdate", "required"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode === 'upload')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("input", {
            type: "file",
            accept: "image/*",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
            class: "block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none",
            required: _ctx.required
          }, null, 40, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    (_ctx.imageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("img", {
            src: _ctx.imageUrl,
            alt: "Image preview",
            class: "rounded-md shadow-lg w-32 h-32 object-cover"
          }, null, 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true)
  ]))
}